import { render, staticRenderFns } from "./InfoLead.vue?vue&type=template&id=61b11103&"
import script from "./InfoLead.vue?vue&type=script&lang=js&"
export * from "./InfoLead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports